import { InternalAuth } from './InternalAuth';
import { KnmFindIndexes } from './KnmFindIndexes';
import { KnmFindPrevious } from './KnmFindPrevious';

export const MOCKS: { [key: keyof typeof MOCKS_DEFAULT]: unknown } = {};

const MOCKS_DEFAULT: { [key: string]: unknown } = {
  '/public/auth/authenticator/api/internalauth/auth': InternalAuth,
  '/erknm-index/api/knm/find-indexes': KnmFindIndexes,
  '/erknm-catalogs/api/knm/find-previous': KnmFindPrevious,
};
